var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJamaicaFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5556 3.6814H2.44444C1.79614 3.6814 1.17438 3.93894 0.715961 4.39736C0.257539 4.85578 0 5.47753 0 6.12584L0 17.1258C0 17.7742 0.257539 18.3959 0.715961 18.8543C1.17438 19.3127 1.79614 19.5703 2.44444 19.5703H19.5556C20.2039 19.5703 20.8256 19.3127 21.284 18.8543C21.7425 18.3959 22 17.7742 22 17.1258V6.12584C22 5.47753 21.7425 4.85578 21.284 4.39736C20.8256 3.93894 20.2039 3.6814 19.5556 3.6814Z",
    fill: "#009B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8546 17.9574C21.9487 17.6977 22 17.4178 22 17.1257V6.12567C22 5.83417 21.9487 5.55428 21.8552 5.29517L21.8546 5.29395L13.0876 11.6257L21.8546 17.9574ZM8.91245 11.6257L0.145445 5.29395V5.29456C0.0489636 5.56102 -0.000256867 5.84228 1.00805e-06 6.12567V17.1257C1.00805e-06 17.4178 0.0513343 17.6977 0.145445 17.9574L8.91245 11.6257Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8824 3.70264L10.9999 10.1181L2.11744 3.70264H2.11683C1.67429 3.76269 1.25662 3.94265 0.909013 4.22304C0.56141 4.50343 0.297127 4.87356 0.144775 5.29336L8.91239 11.6257L0.145387 17.9574L0.145998 17.9592C0.298372 18.3784 0.562386 18.748 0.909516 19.028C1.25665 19.308 1.6737 19.4879 2.11561 19.5481H2.11805L10.9999 13.1333L19.8818 19.5481C20.3243 19.4883 20.7419 19.3085 21.0895 19.0283C21.4371 18.7482 21.7014 18.3782 21.8539 17.9586L21.8545 17.9568L13.0875 11.6257L21.8545 5.29397C21.7024 4.87398 21.4382 4.50365 21.0905 4.22314C20.7429 3.94262 20.3251 3.76261 19.8824 3.70264Z",
    fill: "#FFD202"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.625732)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJamaicaFlag);
export default __webpack_public_path__ + "static/media/jamaica-flag.441089578c49b2438151cc2edcdc4fae.svg";
export { ForwardRef as ReactComponent };